import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { useAnchor } from "hooks";
import { TableSaversContent } from "types/graphql/generated";
import { Table } from "./components";

interface Props {
  content: TableSaversContent;
}

const TableSavers: VFC<Props> = withErrorBoundary(({ content: { title, ...tableContent } }) => {
  useAnchor("table-savers");

  return (
    <StyledTitle className="table-savers Content">
      <div className="Table__container">
        <h2 className="Table__title Font_48_54_600 lg:Font_40_48_600 md:Font_32_40_600">{title}</h2>
        <Table content={tableContent} className="Table__table" />
      </div>
    </StyledTitle>
  );
}, {});

const StyledTitle = styled.section`
  margin-top: -64px;
  padding-top: 64px;

  .Table__container {
    background: ${({ theme }) => theme.colors.coral["05"]};
    padding: 80px 48px;
  }

  .Table__title {
    text-align: center;
  }

  .Table__table {
    display: flex;
    flex-direction: column;
    margin-top: 96px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    &.Content {
      padding-left: 0;
      padding-right: 0;
    }

    .Table__container {
      padding: 64px 32px;
    }

    .Table__title {
      max-width: 550px;
      text-align: left;
    }

    .Table__table {
      margin-top: 64px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Table__container {
      padding: 64px 24px;
    }
  }
`;

gql`
  fragment TableSaversContent on ComponentTableTableSavers {
    title
    ...TableSaversTableContent
  }
`;

export { TableSavers };
export type { Props as TableSaversProps };
